<template>
  <b-dropdown :text="$t('common.transactions')" class="smagria-dropdown transactions m-md-2">
    <b-dropdown-item to="/stock-management/sm-stocks/reception">{{ $t("stock_management.reception.title") }}</b-dropdown-item>
    <b-dropdown-item to="/stock-management/sm-stocks/sales">{{ $t("stock_management.sales.title") }}</b-dropdown-item>
    <b-dropdown-item to="/stock-management/sm-stocks/transfer">{{ $t("stock_management.transfer.transfer_between") }}</b-dropdown-item>
    <b-dropdown-item to="/stock-management/sm-stocks/consum" disabled>{{ $t("stock_management.consum.title") }}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "StockActions",
};
</script>
